import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=638038d4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=638038d4&prod&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=638038d4&prod&lang=scss&scoped=true"
import style2 from "./Header.vue?vue&type=style&index=2&id=638038d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638038d4",
  null
  
)

export default component.exports